module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Already booked","text":"You’ve already booked tickets for this workshop. We can\u0027t wait to see you there!","cta":"Change my booking"},"fr":{"title":"Déjà réservé","text":"Vous avez déjà réservé des tickets pour ce workshop. Nous avons hâte de vous y voir !","cta":"Modifier la réservation"}}')
  delete Component.options._Ctor
}
